import React from 'react';

const cn = (...classes) => classes.filter(Boolean).join(' ');

// Filter chips: "All" (value '') then the API's tag names (spec §4.2). The
// pill is the image-library admin's FolderPill idiom, copied rather than
// imported across views.
const Chip = ({ label, active, onClick }) => (
  <button
    type="button"
    aria-pressed={active}
    onClick={onClick}
    className={cn(
      'shrink-0 rounded-full border px-3 py-1.5 text-xs font-semibold transition',
      active
        ? 'border-blue-600 bg-blue-600 text-white shadow-sm dark:border-sky-500 dark:bg-sky-500 dark:text-slate-900'
        : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:text-slate-900 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300 dark:hover:border-slate-600',
    )}
  >
    {label}
  </button>
);

const TagChips = ({ tags = [], active = '', onChange }) => (
  <div className="flex flex-wrap gap-2" role="group" aria-label="Filter by tag">
    <Chip label="All" active={active === ''} onClick={() => onChange('')} />
    {tags.map((tag) => (
      <Chip key={tag} label={tag} active={active === tag} onClick={() => onChange(tag)} />
    ))}
  </div>
);

export default TagChips;
